// extracted by css-extract-rspack-plugin
export default {"textarea":"Organization_textarea__7cbSw"};